export enum PathParam {
  SaleId = 'saleId',
}
